import {useEffect} from 'react';
import {useLocation} from 'react-router';

/**
 * A station's warnings page and a warning on it (`/warnings/<id>`) are one
 * page whose URL carries the selection; the station id is captured so that
 * another station's warnings still count as a new page.
 */
const WARNINGS_PAGE = /^(\/app\/stations\/\d+\/warnings)(?:\/[^/]+)?\/?$/;

const pageOf = (pathname: string) =>
  WARNINGS_PAGE.exec(pathname)?.[1] ?? pathname;

export default function ScrollToTop() {
  const {pathname} = useLocation();
  // Keyed on the PAGE, not the path: choosing another warning in the list
  // must not throw the reader back to the top of a long list.
  const page = pageOf(pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return null;
}
